export const OPEN_FAN_KEY = 'characteristic-addition-matrix-fan';

const store = {
	namespaced: true,
	state: {
		show: false,
		title: undefined,
		subTitle: undefined,
		type: undefined,
		items: undefined,
		experienceConfig: undefined,
		selfAssessmentConfig: undefined,
		educationConfig: undefined,
		onClose: undefined,
	},
	getters: {
		withExperience: (state) => state.experienceConfig?.enabled,
		withSelfAssessment: (state) => state.selfAssessmentConfig?.enabled,
		withEducation: (state) => state.educationConfig?.enabled,
	},
	actions: {
		show ({commit}, data)
		{
			commit('layout/addOpenFan', OPEN_FAN_KEY, {root: true});

			commit('setType', data.type);
			commit('setTitle', data.title);
			commit('setSubTitle', data.subTitle);
			commit('setItems', data.items);
			commit('setExperienceConfig', data.experienceConfig);
			commit('setSelfAssessmentConfig', data.selfAssessmentConfig);
			commit('setEducationConfig', data.educationConfig);
			commit('setOnClose', data.onClose);

			commit('setShow', true);
		},
		close ({commit, state}, data)
		{
			commit('setShow', false);

			if (state.onClose)
			{
				state.onClose(data);
			}

			commit('setType', undefined);
			commit('setTitle', undefined);
			commit('setSubTitle', undefined);
			commit('setItems', undefined);
			commit('setExperienceConfig', undefined);
			commit('setSelfAssessmentConfig', undefined);
			commit('setEducationConfig', undefined);
			commit('setOnClose', undefined);

			commit('layout/removeOpenFan', OPEN_FAN_KEY, {root: true});
		},
	},
	mutations: {
		setShow: (state, value) => state.show = value,
		setType: (state, value) => state.type = value,
		setTitle: (state, value) => state.title = value,
		setSubTitle: (state, value) => state.subTitle = value,
		setItems: (state, value) => state.items = value,
		setExperienceConfig: (state, value) => state.experienceConfig = value,
		setSelfAssessmentConfig: (state, value) => state.selfAssessmentConfig = value,
		setEducationConfig: (state, value) => state.educationConfig = value,
		setOnClose: (state, value) => state.onClose = value,
	},
};

export default store;
